import PublicDaySchedules from './entities/public-day-schedules';
import PublicScheduleDetails from './entities/public-schedule-details';
import PublicScheduledDates from './entities/public-scheduled-dates';

export default {
  modules: {
    PublicDaySchedules,
    PublicScheduleDetails,
    PublicScheduledDates,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/public/index.js